import Link from 'next/link';
import Image from 'next/image';
import { FC } from 'react';
import { trunc } from '@/helpers/props';
import styles from './BlogPostCard.module.scss';
import Box from '@/components/UI/box/Box';
import Typography from '@/components/UI/typography/Typography';
interface BlogPostCardProps {
  link: string;
  title: string;
  thumbnailPath: string;
}
const BlogPostCard: FC<BlogPostCardProps> = ({
  title,
  link,
  thumbnailPath
}) => {
  return <Link href={link} rel="noreferrer" target="_blank" className={styles['blog-post-card']} data-sentry-element="Link" data-sentry-component="BlogPostCard" data-sentry-source-file="BlogPostCard.tsx">
      <Box className={styles['blog-post-card-image']} data-sentry-element="Box" data-sentry-source-file="BlogPostCard.tsx">
        <Image src={thumbnailPath} alt={title} layout="fill" objectFit="cover" data-sentry-element="Image" data-sentry-source-file="BlogPostCard.tsx" />
      </Box>
      <Box component={'header'} className={styles['blog-post-card-header']} data-sentry-element="Box" data-sentry-source-file="BlogPostCard.tsx">
        <Typography variant={'bodyM'} data-sentry-element="Typography" data-sentry-source-file="BlogPostCard.tsx">{trunc(title, 46)}</Typography>
      </Box>
    </Link>;
};
export default BlogPostCard;